import { FC } from "react";
import { getAvatarUrl } from "entities/user";
import type { UserAvatar } from "entities/user";
import { TrashIcon, UserDefaultIcon, formStyles } from "shared/ui";
import { useAvatar } from "../model/useAvatar";
import { AvatarDropzone } from "./AvatarDropzone";

import profileStyles from "./UserProfile.module.css";
import styles from "./ProfileAvatar.module.css";

interface Props {
  avatar: UserAvatar;
}

export const ProfileAvatar: FC<Props> = ({ avatar }) => {
  const { upload, remove, isBusy, error } = useAvatar();
  const avatarUrl = getAvatarUrl(avatar);

  return (
    <li className={`${profileStyles.listItem} ${styles.avatarItem}`}>
      <p className={profileStyles.label}>Avatar:</p>
      <div className={styles.body}>
        <div className={styles.controls}>
          {avatarUrl ? (
            <img src={avatarUrl} alt="User Avatar" className={styles.image} />
          ) : (
            <UserDefaultIcon />
          )}
          <AvatarDropzone disabled={isBusy} onFile={upload} />
          {avatarUrl && (
            <button
              type="button"
              className={`${formStyles.outlineButton} ${formStyles.danger}`}
              onClick={remove}
              disabled={isBusy}
            >
              <TrashIcon className={formStyles.buttonIcon} />
              Remove
            </button>
          )}
        </div>
        {error && <p className={styles.error}>{error}</p>}
      </div>
    </li>
  );
};
